import React from 'react';

const SvgTt = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="TT_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="TT_svg__b" fill="#fff">
        <use xlinkHref="#TT_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#TT_svg__a" />
      <path fill="#ED233C" mask="url(#TT_svg__b)" d="M0 0h28v20H0z" />
      <path
        fill="#FFF"
        mask="url(#TT_svg__b)"
        transform="matrix(-1 0 0 1 28 0)"
        d="M7.531 25.42L28.063.951 20.469-5.42-.063 19.049l7.594 6.371z"
      />
      <path
        fill="#262626"
        mask="url(#TT_svg__b)"
        transform="matrix(-1 0 0 1 28 0)"
        d="M4.126 26.953l24.855-29.62-5.107-4.286-24.855 29.62 5.107 4.286z"
      />
    </g>
  </svg>
);

export default SvgTt;
